export default {"src":"/_next/static/media/strategic-archival.f5c80a04.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};